import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const editQnsBankApi = createAsyncThunk(
    'qns-bank/edit',
    async (data, { rejectWithValue }) => {
        try {
            const { id: ID, ...rest } = data
            const response = await AuthAxios.patch(apiRoutes.questionBankAction(`update/${ID}`, 0), rest)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const editQnsBankSlice = createSlice({
    name: 'qns-bank/edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(editQnsBankApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(editQnsBankApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(editQnsBankApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const editQnsBankReducer = editQnsBankSlice.reducer